
export interface SettingsInterface{
    tbi_available?: boolean
    languages:{
        name: string
        code: string
        flag:string
    }[]
    free_delivery_price:number
    min_delivery_price:number
    logo:string
    logo_width:number
    logo_height:number
    logo_mobile:string
    logo_mobile_width:number
    logo_mobile_height:number
    favicon:string
    site_title:string
    site_description:string
    footer_text:string
    currency:string
    colors:ThemeColorsInterface
    css_hash:string
    font:string
    font_size:number
    site_id:number
    hide_fast_search:number
    hide_favorite_icon:number
    hide_login_icon:number
    search_show_filters:boolean
    cookie_consent_display?: 'banner' | 'modal'


    //public settings - after mount
    subscriptions?: {
        supported_terms: (1 | 3 | 6 | 12)[]
        shipping_mode: 'prepaid_period' | 'per_order' | 'free'
        checkout_available: boolean
    }
    google_search_console?:string
    cf_enable?:boolean
    cf_site_key?:string
    google_tracking_mode?: 'direct' | 'gtm'
    ga_events_api_enable?: boolean;
    google_ads_id?: string;
    google_ads_purchase_label?: string;
    google_ads_enhanced_conversions?: boolean;
    ga?:string
    gtag?:string
    facebook_pixel?:string
    tiktok_pixel?:string
    openai_enable?:boolean
    openai_pixel?:string
    openai_pixel_enable?:boolean
    openai_pixel_debug?:boolean
    openai_events_api_enable?:boolean
    facebook_events_api_enable?:boolean
    tiktok_events_api_enable?:boolean
    tawk_to?:number
    tawk_property_id?:string
    tawk_widget_id?:string
    ms_clarity:boolean
    ms_clarity_id?:string
    email?:string
    phone?:string
    address?:string
    socials:{
        facebook?:string
        viber?:string
        instagram?:string
        x?:string
        youtube?:string
        tiktok?:string
        google?:string
    }
    gmap?:string
    enable_fast_order?:number
    fast_order_payment_service?:string
    enable_phone_order?:number
    enable_add_to_cart?:number
    digital_menu_order_button?:boolean

    announcement_texts?:Record<string, string | null>
    announcement_enabled?:boolean
    announcement_animation?:boolean
    announcement_color?:string
    announcement_bg?:string
    gift_enable?:boolean
    gift_min_price?:number
    gift_text?:string
    gift_product?:string
    img_ratio?:string
    img_product_page_fill:"contain" | "cover",
    ai_agent_enable?:boolean
    social_login?:{
        google:boolean
        facebook:boolean
    }



}


export const DefaultPrimaryButtonTextColor = '#FFFFFF';

export const DefaultThemeColors:ThemeColorsInterface={
  primary:'#16A34A',
  info:'#888',
    link:'#16A34A',
    body:{
        bg:'fff',
        color:'#212121'
    },
  menu:{
    border:'#16A34A',
    bg:'#16A34A',
    text:'#F6F7FB',
    text_hover:'#F6F7FB',
    mega:{
      bg:'#16A34A',
      text:'#F6F7FB',
      text_hover:'#F6F7FB',
    },
    mobile:{
        background:'#fff',
        color:'#000',
    }
  },
    footer:{
      bg:'fff',
        color:'#212121',
    }
}

export type ThemeColorsInterface = {
  primary: string
  primary_button_text?: string
  info: string
  link:string
    body:{
        bg:string
        color:string
    }
  menu: {
    border: string
    bg: string
    text: string
    text_hover: string
    mega: {
      bg: string
      text: string
      text_hover: string
    }
    mobile:{
        background:string
        color:string
    }
  }
  footer:{
      bg:string
      color:string
  }
}
